import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { UserDto, UsersApi } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseGetUser = (
  usersApi: UsersApi,
  id: string,
  options: UseQueryOptions<UserDto, ErrorResponse, UserDto, string[]>,
) => UseQueryResult<UserDto>;


export const useGetUser: UseGetUser = (usersApi, id, options) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useQuery(
    [`user-${id}`],
    async () => usersApi.getUser(tenantId, id).then(({ data }) => data),
    options,
  );
};
